<template>
    <section class="faq-sec">
        <div class="faq-container">
            <h2>سوالات متداول</h2>
            <div class="faq-list">
                <div v-for="(item, index) in faqList" :key="index" ref="faqBoxes" class="faq-box" @click="toggle(index)"
                 :class="{ 'faq-box-active': isActive(index), 'fade-in': isVisible(index) }">
                    <div  class="faq-question">
                        <p>{{ item.q }}</p>
                        <span class="que-close icon" :class="{ 'que-open': isActive(index) }"></span>
                    </div>
                    <div v-show="isActive(index)" class="faq-answer">
                        <p v-html="item.a"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
export default {
    name: "FAQ",
    props: {
        faqList: {
          type: Array,
          required: true
        },
    },
    setup() {
        const activeIndexes = ref([]);
        const faqBoxes = ref([]);
        const visibleIndexes = ref([]);

        function toggle(index) {
          const i = activeIndexes.value.indexOf(index);
          if (i !== -1) {
            activeIndexes.value.splice(i, 1);
          } else {
            activeIndexes.value.push(index);
          }
        }

        function isActive(index) {
          return activeIndexes.value.includes(index);
        }

        function isVisible(index) {
            return visibleIndexes.value.includes(index);
        }

        function checkVisibility() {
          faqBoxes.value.forEach((el, i) => {
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            if (rect.top < windowHeight && rect.bottom > 0) {
              if (!visibleIndexes.value.includes(i)) {
                visibleIndexes.value.push(i);
              }
            }
          });
        }

        onMounted(() => {
          faqBoxes.value = faqBoxes.value.filter(Boolean);
          window.addEventListener('scroll', checkVisibility);
          checkVisibility();
        });

        onUnmounted(() => {
          window.removeEventListener('scroll', checkVisibility);
        });

        return {
            toggle,
            isActive,
            faqBoxes,
            isVisible,
        }

    }
};
</script>

<style scoped>
.faq-sec {
    margin-bottom: 178px;
    background: linear-gradient(rgba(255, 171, 184, 0) 0%, rgba(248, 187, 208, 0.29) 50%, rgba(251, 179, 196, 0) 100%);
}

.faq-container {
    margin-inline: 10.973% 22.16%;
    align-items: stretch;
    gap: 36px;
}

.faq-container,
.faq-list {
     flex-direction: column;
}

.faq-container,
.faq-list,
.faq-question {
    display: flex;
}

.faq-box {
    background-color: #FFFFFF;
    border-radius: 20px;
    box-shadow: 0 2px 10px var(--shadow-light);
    padding: 30px 34px;
    cursor: pointer;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 2s ease, transform 2s ease;
}

.faq-box.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.faq-box-active {
    background-color: var(--glass-morphism);
}

.faq-container h2 {
    align-self: flex-start;
    font-size: 28px;
    line-height: 38px;
}

.faq-container h2,
.faq-question p {
    font-family: 'IRANYekan-Bold';
}

.faq-list {
    margin-right: 16.73%;
    gap: 24px;
}

.faq-question {
     align-items: center;
    justify-content: space-between;
}

.faq-question p {
    line-height: 28px;
}

.faq-answer {
    text-align: justify;
}

.faq-answer p {
    font-size: 16px;
    line-height: 24px;
    margin-top: 2.46%;
    margin-inline: 3%;
}

::v-deep .faq-answer a {
  color: #000000;
  font-size: 16px;
  line-height: 24px;
}

.que-close {
    background-image: url('../assets/images/submenu-icon.svg');
    transition: transform 0.5s ease;
}

.que-open {
    transform: rotate(180deg);
}

@media screen and (min-width:1441px) {
    .faq-container {
        width: 963px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .faq-sec {
        background: none;
    }

    .faq-container {
        gap: 24px;
    }

    .faq-container h2 {
        font-size: 24px;
        line-height: 28px;
    }
}

@media screen and (max-width: 768px) {
    .faq-container {
        margin-inline: 31px;
        gap: 16px;
    }

    .faq-list {
        margin-right: 0;
        gap: 20px;
    }

    .faq-box  {
        padding: 11.5px 10.5px;
    }

    .faq-question p {
        font-size: 16px;
        line-height: 26px;
    }

    .faq-answer p {
        font-size: 14px;
        line-height: 20px;
    }

    ::v-deep .faq-answer a {
       font-size: 14px;
       line-height: 20px;
    }
}

@media screen and (max-width: 375px) {
    .faq-sec {
         margin-bottom: 150px;
    }

    .faq-container h2 {
        font-size: 20px;
    }

    .faq-question p {
        font-size: 13px;
    }

    .faq-answer p {
        font-size: 12px;
    }

    ::v-deep .faq-answer a {
       font-size: 12px;
    }
}

</style>
